<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <Loader cover v-if="local.isProcessing"/>

    <div id="algolia-content-container" class="relative clearfix">

      <div class="items-grid-view vx-row match-height">
        <div  class="vx-col lg:w-1/3 sm:w-1/2 w-full" v-for="item in courseOutlines" :key="item.id">
          <item-course-outline-grid-view :item="item">

          </item-course-outline-grid-view>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import ItemCourseOutlineGridView from './components/ItemCourseOutlineGridView'

  import {state, loadData} from './data';
  import CourseOutline from '@/store/modules/class-room/class-room/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.CourseOutline) state.registerModule(`CourseOutline`, CourseOutline);

  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);


  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });

  export default {
    components: {
      ItemCourseOutlineGridView,
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    },
    data() {
      return {
        state: state,
        store: state.store,
        local: state.local,

      }
    },
    computed: {
      ...mapCourseOutlineFields({courseOutlineProcessing: 'processing',}),
      courseOutlines() {
        return this.local.courseOutlines;
      },
    },
    watch: {
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapCourseOutlineActions({
        getCourseOutlinesByFilter: 'getCourseOutlinesByFilter',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//


      //---------------------------------------- Local Function ------------------------------------------------------//

      async loadData() {
        let func = {getCourseOutlinesByFilter: this.getCourseOutlinesByFilter};
        await loadData(func);
      },
    },
    async mounted() {
      await this.loadData();
    },
  }

</script>


<style lang="scss">
  #algolia-instant-search-demo {
    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #algolia-instant-search-demo {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

